import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";
import Button from "components/Button";

import { sizes, colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

type GroupInfoBoxType = {
  icon?: IconT;
  title?: string;
  onEdit: () => void;
  onDelete: () => void;
  onPress?: () => void;
  onLongPress?: () => void;
  activeOpacity?: number;
  renderContent?: () => JSX.Element;
  disabled?: boolean;
  selected?: boolean;
};

export default function GroupInfoBox(props: GroupInfoBoxType) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);
  const { renderContent, onDelete, onEdit, icon, title, disabled } = props;

  return (
    <TouchableOpacity
      activeOpacity={props.activeOpacity || 0.9}
      onPress={props.onPress}
      onLongPress={props.onLongPress}
      style={{
        ...styles.container,
        borderColor: props.selected ? color + "33" : colors.transparent,
      }}
    >
      <View style={styles.rowCenterAlign}>
        {!disabled && (
          <>
            <Button
              disabled={disabled}
              onPress={onDelete}
              bgColor={"#f8f8f8"}
              square={35}
              icon={{ name: "trash-2", color: colors.danger }}
              style={{ marginRight: sizes.space / 2 }}
            />
            <Button
              disabled={disabled}
              onPress={onEdit}
              bgColor={"#f8f8f8"}
              square={35}
              icon={{ name: "edit-2", color: colors.info }}
            />
          </>
        )}
        <View style={styles.flex} />
        <Text
          style={{ lineHeight: 18, top: 0, marginRight: 5 }}
          numberOfLines={1}
          weight="bold"
        >
          {title}
        </Text>
        {icon && <Icon {...icon} color={color} />}
      </View>
      {renderContent && (
        <View style={{ ...styles.flex, padding: sizes.space / 2 }}>
          {renderContent()}
        </View>
      )}
      {props.selected && (
        <Button
          disabled
          icon={{ name: "check", size: 15 }}
          absolute
          right={-6}
          top={-6}
          style={{ width: 20, height: 20, borderRadius: 20 }}
        />
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    borderWidth: 1,
    alignSelf: "center",
    padding: sizes.space / 2,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.white,
  },

  buttonsContainer: {
    top: 15,
    width: 100,
    flexDirection: "row",
    position: "absolute",
  },

  flex: { flex: 1 },

  rowCenterAlign: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 35,
  },
});
